/* eslint-disable react-hooks/exhaustive-deps */
import { ConnectedProps, connect } from "react-redux";
import {
  Content,
} from "./firebaseUi.styled";
import { FirebaseUiProps } from "./firebaseUi.type";
import { auth } from "@config/firebase/firbaseConfig";
import { useEffect, useRef, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import * as firebaseui from 'firebaseui';
import 'firebaseui/dist/firebaseui.css';
import 'firebase/compat/auth';

type ReduxProps = ConnectedProps<typeof connector>;

const StyledFirebaseAuth = ({
  uiConfig, firebaseAuth, className, uiCallback
}: FirebaseUiProps & ReduxProps) => {

 const [userSignedIn, setUserSignedIn] = useState(false);
    const elementRef = useRef(null);
    useEffect(() => {
        // Get or Create a firebaseUI instance.
        const firebaseUiWidget = firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(auth);
        if (uiConfig.signInFlow === 'popup')
            firebaseUiWidget.reset();

        // We track the auth state to reset firebaseUi if the user signs out.
        const unregisterAuthObserver = onAuthStateChanged(auth, (user) => {
            if (!user && userSignedIn)
                firebaseUiWidget.reset();
            setUserSignedIn(!!user);
        });

        // Trigger the callback if any was set.
        if (uiCallback)
            uiCallback(firebaseUiWidget);

        // Render the firebaseUi Widget.
        // @ts-ignore
        firebaseUiWidget.start(elementRef.current, uiConfig);

        return () => {
            unregisterAuthObserver();
            firebaseUiWidget.reset();
        };
    }, [uiCallback, userSignedIn]);

    return <Content className={className} ref={elementRef} />;
};


const mapDispatchToProps = {};

const connector = connect(undefined, mapDispatchToProps);
const StyledFirebaseAuthRedux = connector(StyledFirebaseAuth);

export { StyledFirebaseAuthRedux as StyledFirebaseAuth };
